"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cookie = void 0;
var Cookie = (function () {
    function Cookie() {
    }
    Cookie.get = function (c_name) {
        var name = c_name + "=";
        var decoded_cookie = decodeURIComponent(document.cookie);
        var carr = decoded_cookie.split(";");
        for (var i = 0; i < carr.length; i++) {
            var c = carr[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    };
    Cookie.set = function (c_name, value, expireminutes) {
        if (expireminutes === void 0) { expireminutes = 10080; }
        var exdate = new Date();
        exdate.setMinutes(exdate.getMinutes() + expireminutes);
        document.cookie =
            c_name +
                "=" +
                escape(value) +
                (expireminutes == null ? "" : ";expires=" + exdate.toUTCString());
    };
    Cookie.clear = function (c_name) {
        Cookie.set(c_name, "", -1);
    };
    return Cookie;
}());
exports.Cookie = Cookie;
//# sourceMappingURL=Cookie.js.map